<template>
    <div v-if="isSaaS == true" class="rsv_msg_wrap">
        <EditAlertPopup v-if=isShowEditAlert @hideAlert="hideEditAlert"/>
        <div :ref="'table'" class="rsv_msg_txt_set table_header_fix" style="height:500px">
            <table class="table2_default small no_hover">
                <tr>
                    <th width="120px" class="txt_center">{{ $t('reservation_settings.popup_group_settings.label_sending_time') }}</th>
                    <th class="txt_center">{{ $t('reservation_settings.popup_group_settings.label_noti_content') }}</th>
                    <th width="70px" class="txt_center">{{ $t('reservation_settings.popup_group_settings.label_use') }}</th>
                </tr>
                <NoticeMessageComponent
                    v-for="(data, index) in messageComponetData" :key=index
                    :ref="data.key"
                    :templateKey="data.key"
                    :noticeTitle="data.title"
                    v-model="group"
                    @showPreview="showPreview"
                    @showEditAlert="showEditAlert"
                    @updatePreview="updatePreview"
                    @updateGroup="updateGroup"
                />
            </table>
        </div>
        <div class="rsv_msg_info relative">
            <div class="txt_preview_wrap" v-if="isShowPreview">
                <div class="txt_preview_top">
                    <span class="txt_preview_title">{{ $t('reservation_settings.popup_group_settings.label_preview_message') }}</span>
                    <a class="mgl_auto" @click="hidePreview"><v-icon small>mdi-close</v-icon></a>
                </div>
                <div class="txt_preview_cont">
                    <div class="bubble"><pre>{{ previewMessage }}</pre></div>
                </div>
            </div>
            <table class="table2_default no_hover">
                <colgroup>
                    <col width="115px">
                    <col width="">
                </colgroup>
                <tr>
                    <th colspan="2">
                        {{ $t('reservation_settings.popup_group_settings.label_refer_to_placeholders') }}
                        <v-icon class="btn_tooltip">mdi-alert-circle-outline</v-icon>
                        <span class="tooltip_wrap">
                            <span class="tooltip">
                                {{ $t('reservation_settings.popup_group_settings.label_refer_to_placeholders_description') }}
                            </span>
                        </span>
                    </th>
                </tr>
                <tr>
                    <th>{{ $t('reservation_settings.popup_group_settings.label_input') }}</th>
                    <th>{{ $t('reservation_settings.popup_group_settings.label_example_refer_to_placeholders') }}</th>
                </tr>
                <tr>
                    <td><span class="label lgray" v-pre>{{고객명}}</span></td>
                    <td>홍길동</td>
                </tr>
                <tr>
                    <td><span class="label lgray" v-pre>{{프로그램명}}</span></td>
                    <td>도수치료 A코스</td>
                </tr>
                <tr>
                    <td><span class="label lgray" v-pre>{{담당자명}}</span></td>
                    <td>이철수</td>
                </tr>
                <tr>
                    <td><span class="label lgray" v-pre>{{예약일시}}</span></td>
                    <td>2023년 07월 03일(월) 13:00</td>
                </tr>
                <tr>
                    <td><span class="label lgray" v-pre>{{예약일}}</span></td>
                    <td>2023년 07월 03일(월)</td>
                </tr>
                <tr>
                    <td><span class="label lgray" v-pre>{{시작시간}}</span></td>
                    <td>13:00</td>
                </tr>
                <tr>
                    <td><span class="label lgray" v-pre>{{종료시간}}</span></td>
                    <td>14:00</td>
                </tr>
            </table>
        </div>
    </div>
</template>


<script>
import NoticeMessageComponent from './NoticeMessageComponent'
import EditAlertPopup from './EditAlertPopup'

const MESSAGE_COMPONENT_DATA = [
    { key: 'messageImmediateCreate', title: 'reservation_settings.popup_group_settings.label_upon_new_registration' },
    { key: 'messageImmediateUpdate', title: 'reservation_settings.popup_group_settings.label_upon_modification' },
    { key: 'messageImmediateRemove', title: 'reservation_settings.popup_group_settings.label_upon_cancel' },
    { key: 'messageReservationBefore0', title: 'reservation_settings.popup_group_settings.label_on_day_of_visit' },
    { key: 'messageReservationBefore1', title: 'reservation_settings.popup_group_settings.label_on_1day_before_visit' },
    { key: 'messageReservationBefore3', title: 'reservation_settings.popup_group_settings.label_on_3days_before_visit' },
]

export default {
    components: { NoticeMessageComponent, EditAlertPopup },
    props: {
        group: Object,
    },
    data() {
        return {
            isFirstEdit: true,
            isShowEditAlert: false,
            alertData: {
                'messageImmediateCreate': false,
                'messageImmediateUpdate': false,
                'messageImmediateRemove': false,
                'messageReservationBefore0': false,
                'messageReservationBefore1': false,
                'messageReservationBefore3': false,
            },
            lastAlertKey: undefined,
            tableHeight: -1,

            messageComponetData: MESSAGE_COMPONENT_DATA.map(item => ({
                ...item,
                title: this.$t(item.title)
            })),
            
            previewMessage: undefined,
            previewTemplatKey: undefined,
        }
    },
    watch: {},
    computed: {
        isSaaS: function() { return this.hospital.selectedHospital.isEnabledSaaS },
        isShowPreview: function() { return this.previewMessage != undefined },
    },
    methods: {
        // MARK: - Private
        showPreview({templateKey, message}) {
            this.previewTemplateKey = templateKey
            this.previewMessage = message
        },
        updatePreview({templateKey, message}) {
            if (templateKey == this.previewTemplateKey) { this.previewMessage = message }
        },
        hidePreview() {
            this.previewTemplateKey = undefined
            this.previewMessage = undefined
        },

        showEditAlert(key) {
            if (this.alertData[key] == true) { return }
            this.$refs[key][0].$refs.textarea.blur()
            this.lastAlertKey = key
            this.isShowEditAlert = true
        },
        hideEditAlert(isConfirm) {
            if (isConfirm) {
                this.alertData[this.lastAlertKey] = true
                this.$refs[this.lastAlertKey][0].$refs.textarea.focus()
            }
            else {
                const textarea = this.$refs[this.lastAlertKey][0].$refs.textarea
                this.$nextTick( () => {
                    textarea.blur()
                })
            }
            this.isShowEditAlert = false
            this.lastAlertKey = undefined
        },

        // MARK: - Emit
        updateGroup({templateKey, isUsingMessage, messageTime, content}) {
            switch (templateKey) {
                case 'messageImmediateCreate':
                    this.group.messageImmediateCreate = content
                    break
                case 'messageImmediateUpdate':
                    this.group.messageImmediateUpdate = content
                    break
                case 'messageImmediateRemove':
                    this.group.messageImmediateRemove = content
                    break
                case 'messageReservationBefore0':
                    this.group.usingMessageReservationBefore0 = isUsingMessage
                    this.group.messageTimeReservationBefore0 = messageTime
                    this.group.messageReservationBefore0 = content
                    break
                case 'messageReservationBefore1':
                    this.group.usingMessageReservationBefore1 = isUsingMessage
                    this.group.messageTimeReservationBefore1 = messageTime
                    this.group.messageReservationBefore1 = content
                    break
                case 'messageReservationBefore3':
                    this.group.usingMessageReservationBefore3 = isUsingMessage
                    this.group.messageTimeReservationBefore3 = messageTime
                    this.group.messageReservationBefore3 = content
                    break
            }
        },
    },
}
</script>